import React from 'react';

const PreCacheFonts = () => {
    return <>
        <div
            style={
                {
                    width: 0,
                    height: 0,
                    overflow: 'hidden'
                }
            }
        >
            <span style={
                {
                    fontFamily: "Roboto",
                    fontWeight: 400
                }
            }></span>
            <span style={
                {
                    fontFamily: "Roboto",
                    fontWeight: 500
                }
            }></span>
            <span style={
                {
                    fontFamily: "Ubuntu",
                    fontWeight: 400
                }
            }></span>
            <span style={
                {
                    fontFamily: "Ubuntu",
                    fontWeight: 500
                }
            }></span>
        </div>
    </>
}

export default PreCacheFonts;
